import { type MutableRefObject } from 'react'

import {
  ExpenseLineItemForm,
  type ExpenseLineItemFormHandle,
} from '@webapp/modules/expense/components/ExpenseLineItemForm'
import { type ExpenseMileageConfiguration } from '@webapp/modules/expense/entities'
import { type ExpenseFormReimbursementCustomization } from '@webapp/modules/expense/entities/enums'
import { type ExpenseItem } from '@webapp/modules/expense/entities/ExpenseItem'
import { type RequestMileageConfiguration } from '@webapp/modules/expense/entities/RequestMileageConfiguration'
import { useEditExpenseLineItemPresenter } from './useEditExpenseLineItemPresenter'

export interface IEditExpenseLineItemPresenterProps {
  item: ExpenseItem
  expenseReportId: number
  requesterId: number
  secondaryCategoryId: number | undefined
  reimbursementSetting: ExpenseFormReimbursementCustomization
  mileageConfiguration?: Nullable<ExpenseMileageConfiguration>
  /**
   * To be removed with PAY_3067_ENHANCE_MILEAGE_EXPENSE_ITEMS
   */
  mileageLockSetting?: RequestMileageConfiguration | null
  attachment: string
  attachmentMimetype: string
  onSuccess: () => void
  formRef?: MutableRefObject<ExpenseLineItemFormHandle | null>
  onSubmittingChange?: (isSubmitting: boolean) => void
  canOverrideTaxAmount?: boolean
}

export const EditExpenseLineItemPresenter = ({
  item,
  expenseReportId,
  requesterId,
  secondaryCategoryId,
  reimbursementSetting,
  mileageLockSetting = null,
  mileageConfiguration = null,
  attachment,
  attachmentMimetype,
  onSuccess,
  formRef,
  onSubmittingChange,
  canOverrideTaxAmount = false,
}: IEditExpenseLineItemPresenterProps) => {
  const {
    commands: { handleSubmit },
    states: { isSubmitting },
  } = useEditExpenseLineItemPresenter({
    item,
    expenseReportId,
    onSuccess,
    onSubmittingChange,
  })

  return (
    <ExpenseLineItemForm
      item={item}
      reimbursementSetting={reimbursementSetting}
      secondaryCategoryId={secondaryCategoryId}
      requesterId={requesterId}
      attachment={attachment}
      attachmentMimetype={attachmentMimetype}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      formRef={formRef}
      mileageLockSetting={mileageLockSetting}
      mileageConfiguration={mileageConfiguration}
      canOverrideTaxAmount={canOverrideTaxAmount}
    />
  )
}
